export class ReconnectRestoreAccountResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccount",
            "baseName": "restoreAccount",
            "type": "RestoreAccount",
            "format": ""
        },
        {
            "name": "actionApprovalRequest",
            "baseName": "actionApprovalRequest",
            "type": "MPARequest",
            "format": ""
        },
        {
            "name": "mpaPolicies",
            "baseName": "mpaPolicies",
            "type": "MPAPoliciesInfo",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReconnectRestoreAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
